import type { ChangePasswordRequest } from '../types/profile.types';
import type { IHttpResponse } from '@/core/api/HttpClient';
import httpClient from '@/core/api/createAxiosHttpClient';

export const profileApi = {
  /**
   * Cambia la contraseña del administrador autenticado.
   * Preserva la sesión actual; revoca las demás. Backend envía email de confirmación.
   */
  changePassword: async (data: ChangePasswordRequest): Promise<IHttpResponse<void>> => {
    return await httpClient.post<ChangePasswordRequest, void>('/admin/auth/change-password', data);
  },
};
